import { useContext, useEffect, useMemo } from "react";
import getConfig from "../configs/tableConfig";
import BeelditTableHeaderActions from "@beeldit/core/components/BeelditTableHeaderActions";
import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";
import { t } from "i18next";
import { Card } from "react-bootstrap";
import useDetailsAction from "../actions/details/useDetailsAction";
import useCustomerListAction from "@beeldit/ecommerce/super-orders/actions/list/useCustomerListAction";

function CustomerSuperOrdersPage(props: any) {
  const { filters, formDefaultValues } = props;

  const { user } = useContext(AuthContext);

  const {
    indexFunction,
    actionTemplate: listActionTemplate,
    setTableConfig,
  } = useCustomerListAction(user, filters);

  const { detailsFunction } = useDetailsAction(0);

  /**<newActionsHooks**/

  /**
   * Table configuration definition
   */
  const memoTableConfig = useMemo(
    () =>
      getConfig({
        detailsFunction,
        indexFunction,
        /**newActionsTableConfig**/
      }),
    [detailsFunction, indexFunction]
  );

  useEffect(() => {
    setTableConfig(memoTableConfig);
  }, [memoTableConfig, setTableConfig]);

  return (
    <Card>
      <Card.Header>
        <Card.Title>{t("super_orders")}</Card.Title>
        <BeelditTableHeaderActions actions={memoTableConfig.actions} />
      </Card.Header>

      <Card.Body>{listActionTemplate}</Card.Body>
    </Card>
  );
}

export default CustomerSuperOrdersPage;
